import { Action } from 'redux';
import {
  OneWayFeeModel
} from '../../../api/pricing/pricing.types';

export const LIST_ALL_ONE_WAY_FEES = 'LIST_ALL_ONE_WAY_FEES';
export const ADD_ONE_WAY_FEES = 'ADD_ONE_WAY_FEES';
export const ADD_ONE_WAY_FEE = 'ADD_ONE_WAY_FEE';

export interface OneWayFeesState {
  oneWayFees: OneWayFeeModel[] | [];
  oneWayFee: OneWayFeeModel | null;
  lastFetch: number | null;
}

export interface GetOneWayFeeList extends Action {
  type: typeof LIST_ALL_ONE_WAY_FEES;
  payload: {
    oneWayFees: OneWayFeeModel[];
  };
}

export interface AddOneWayFeesAction extends Action {
  type: typeof ADD_ONE_WAY_FEES;
  payload: {
    oneWayFees: OneWayFeeModel[];
  };
}

export interface AddOneWayFeeAction extends Action {
  type: typeof ADD_ONE_WAY_FEE;
  payload: {
    oneWayFee: OneWayFeeModel | null;
  }
}


export type OneWayFeeActionTypes = GetOneWayFeeList | AddOneWayFeesAction | AddOneWayFeeAction;
